<template>
  <div id="MainCy" style="width: 100%;height: 100%;"></div>
</template>

<script>
import cytoscape from "../../cytoscape/cytoscape.min.js";
import sbgnStylesheet from "../../cytoscape/bundle.js";
import routeData from "./jq_process_E2SB_IP.json";

export default {
  name: 'MainCy',
  data() {
    return {
    }
  },
  mounted() {
    const { showCy, showCy2 } = this;
    //showCy()
    console.log('showCy')
    showCy2()
  },
  methods: {
    showCy2() {
      var cy = window.cy = cytoscape({
        container: document.getElementById('MainCy'),
        elements: routeData,
        layout: { name: 'preset' },
        style: sbgnStylesheet(cytoscape)
      });
      cy.fit()
    },
    exportCyJson() {
      console.log(window.cy.json())
    },
    showCy() {
      var cy = cytoscape({
        container: document.getElementById('MainCy'),
        layout: {
          name: 'breadthfirst',
          directed: false,
          padding: 10
        },
        style: [
          {
            selector: 'node',
            style: {
              'content': 'data(desc)',
              'text-valign': 'bottom',
              'text-wrap': 'wrap',
              'color': '#fff',
              'height': 160,
              'width': 160,
              'background-fit': 'cover',
              'border-color': '#000',
              'border-width': 3,
              'border-opacity': 0.5
            }
          },
          {
            selector: '.eating',
            style: {
              'border-color': 'red'
            }
          },
          {
            selector: '.eater',
            style: {
              'border-width': 9
            }
          },
          {
            selector: 'edge',
            style: {
              'content': 'data(relationship)',
              'color': '#fff',
              'curve-style': 'bezier',
              'width': 6,
              'target-arrow-shape': 'triangle',
              'line-color': '#ffaaaa',
              'target-arrow-color': '#ffaaaa'
            }
          },
          {
            selector: '#bird',
            style: {
              'background-image': 'https://live.staticflickr.com/7272/7633179468_3e19e45a0c_b.jpg'
            }
          },
          {
            selector: '#cat',
            style: {
              'background-image': 'https://live.staticflickr.com/1261/1413379559_412a540d29_b.jpg'
            }
          },
          {
            selector: '#ladybug',
            style: {
              'background-image': 'https://live.staticflickr.com/3063/2751740612_af11fb090b_b.jpg'
            }
          },
          {
            selector: '#aphid',
            style: {
              'background-image': 'https://live.staticflickr.com/8316/8003798443_32d01257c8_b.jpg'
            }
          },
          {
            selector: '#rose',
            style: {
              'background-image': 'https://live.staticflickr.com/5109/5817854163_eaccd688f5_b.jpg'
            }
          },
          {
            selector: '#grasshopper',
            style: {
              'background-image': 'https://live.staticflickr.com/6098/6224655456_f4c3c98589_b.jpg'
            }
          },
          {
            selector: '#plant',
            style: {
              'background-image': 'https://live.staticflickr.com/3866/14420309584_78bf471658_b.jpg'
            }
          },
          {
            selector: '#wheat',
            style: {
              'background-image': 'https://live.staticflickr.com/2660/3715569167_7e978e8319_b.jpg'
            }
          },
        ],
        elements: {
          nodes: [
            {
              data: {
                id: 'cat',
                name: 'Cat',
                desc: 'for test\nCat'
              }
            },
            {
              data: {
                id: 'bird',
                name: 'Bird',
                desc: 'for test\nBird'
              }
            },
            {
              data: {
                id: 'ladybug',
                name: 'Ladybug',
                desc: 'for test\nLadybug'
              }
            },
            {
              data: {
                id: 'aphid',
                name: 'Aphid',
                desc: 'for test\nAphid'
              }
            },
            {
              data: {
                id: 'rose',
                name: 'Rose',
                desc: 'for test\nRose'
              }
            },
            {
              data: {
                id: 'grasshopper',
                name: 'Grasshopper',
                desc: 'for test\nGrasshopper'
              }
            },
            {
              data: {
                id: 'plant',
                name: 'Plant',
                desc: 'for test\nPlant'
              }
            },
            {
              data: {
                id: 'wheat',
                name: 'Wheat',
                desc: 'for test\nWheat'
              }
            }
          ],
          edges: [
            {
              data: {
                source: 'cat',
                target: 'bird'
              }
            },
            {
              data: {
                source: 'bird',
                target: 'ladybug'
              }
            },
            {
              data: {
                source: 'bird',
                target: 'grasshopper'
              }
            },
            {
              data: {
                source: 'grasshopper',
                target: 'plant'
              }
            },
            {
              data: {
                source: 'grasshopper',
                target: 'wheat',
                relationship: '11'
              }
            },
            {
              data: {
                source: 'ladybug',
                target: 'aphid',
                relationship: '12'
              }
            },
            {
              data: {
                source: 'aphid',
                target: 'rose',
                relationship: '13'
              }
            }
          ]
        }
      });
      cy.nodes().on('click', (evt) => {
        console.log(evt)
      });
      cy.edges().on('click', (evt) => {
        console.log(evt)
      });

    }
  }
};

</script>

<style lang="less" scoped>
#emptop {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
}
.one {
  float: left;
  width: 33%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  text-align: center;
}
.imgdiv {
  width: 100%;
  height: 100%;
  // display: table-cell;
  vertical-align: middle;
  text-align: center;
  display: inline-block;
}
.imgdxx {
  margin: 15px;
  width: 90%;
  height: 90%;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.zz {
}
</style>
